import { defineStore } from 'pinia'
import { setLanguage } from '@/i18n'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    language: null, theme: null, country: 'us', showCrossedItems: true, introSeen: false,
  }),
  getters: {
    isNative: () => window.Capacitor && window.Capacitor.isNativePlatform(),
  },
  actions: {
    async setLanguage (lang) {
      this.language = lang
      await setLanguage(lang)
    }, setTheme (theme) {
      this.theme = theme
    }, setCountry (country) {
      this.country = country
    }, setShowCrossedItems (show) {
      this.showCrossedItems = show
    }, setIntroSeen (seen) {
      this.introSeen = seen
    }
  }, persist: true,
})
